
import { useNavigate, useLocation } from 'react-router-dom';

export default function TabBar() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Don't show tab bar on whiteboard editor pages (specific whiteboard IDs), but show on main whiteboard page
  if (location.pathname.startsWith('/whiteboard/') && location.pathname !== '/whiteboard') {
    return null;
  }
  
  const tabs = [
    { path: '/', icon: 'ri-home-line', label: 'Home' },
    { path: '/games', icon: 'ri-gamepad-line', label: 'Games' },
    { path: '/whiteboard', icon: 'ri-artboard-line', label: 'Whiteboard' },
    { path: '/progress', icon: 'ri-bar-chart-line', label: 'Progress' }
  ];
  
  return (
    <nav className="fixed bottom-0 w-full bg-white/95 backdrop-blur-sm border-t-2 border-gray-200 shadow-2xl z-50">
      <div className="grid grid-cols-4 h-20">
        {tabs.map((tab) => (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={`flex flex-col items-center justify-center space-y-1 transition-all duration-200 ${
              location.pathname === tab.path 
                ? 'text-[#2d5a35] bg-green-50 scale-110 shadow-lg' 
                : 'text-gray-500 hover:text-[#2d5a35] hover:bg-green-50 hover:scale-105'
            }`}
          >
            <div className={`flex items-center justify-center rounded-full transition-all ${
              location.pathname === tab.path 
                ? 'w-10 h-10 bg-[#2d5a35] text-white shadow-lg' 
                : 'w-8 h-8'
            }`}>
              <i className={`${tab.icon} ${location.pathname === tab.path ? 'text-xl' : 'text-lg'}`}></i>
            </div>
            <span className={`text-xs font-medium ${
              location.pathname === tab.path ? 'font-bold' : ''
            }`}>
              {tab.label}
            </span>
          </button>
        ))}
      </div>
    </nav>
  );
}
